import { requirePermission } from "@lib/permissions/guards";
import { createFileRoute } from "@tanstack/react-router";
import TaxeParafiscaleView from "@/features/ventes/components/tarifs/TaxeParafiscaleView";
import { TARIF_PERMISSIONS } from "@/features/ventes/config/tarifs/constants";

export const Route = createFileRoute("/_app/ventes/tarifs/taxes/$id/view")({
  loader: requirePermission(TARIF_PERMISSIONS.TAXES_VIEW),
  staticData: {
    title: "Détails taxe parafiscale",
    showInBreadcrumb: true,
  },
  component: TaxeParafiscaleView,
});
